export default __webpack_public_path__ + "media/images/features/ja/flow_sp-3497e56e3678412dd2e02e11b301e4a1.png";